export const REDUCED_CAMERA_MOTION_KEY = 'cars.reduced-camera-motion';

interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export function readReducedCameraMotion(storage?: StorageLike): boolean {
  const target = storage ?? browserStorage();
  if (!target) return false;
  try {
    return target.getItem(REDUCED_CAMERA_MOTION_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeReducedCameraMotion(enabled: boolean, storage?: StorageLike): void {
  const target = storage ?? browserStorage();
  if (!target) return;
  try {
    target.setItem(REDUCED_CAMERA_MOTION_KEY, String(enabled));
  } catch {
    // Private browsing and disabled storage should not prevent a race.
  }
}

function browserStorage(): StorageLike | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}
